import React from "react";
import { FOOTER } from "../constants/testIds";
import { BRAND, WHATSAPP_DISPLAY } from "../constants/site";
import { Link } from "react-router-dom";
import { useSiteSettings } from "../hooks/useSiteSettings";

const COLUMNS = [
    {
        title: "Catalogue",
        links: [
            { label: "Turbines et instrumentation rotative", to: "/instrumentation-rotative/" },
            { label: "Consommables dentaires", to: "/consommables-dentaires/" },
            { label: "Tous les produits", to: "/#produits" },
        ],
    },
    {
        title: "Implantologie",
        links: [
            { label: "Matériel d'implantologie", to: "/implantologie/" },
            { label: "Moteurs implantaires", to: "/implantologie/" },
        ],
    },
    {
        title: "Endodontie",
        links: [
            { label: "Matériel d'endodontie", to: "/endodontie/" },
            { label: "Endomoteurs et limes NiTi", to: "/endodontie/" },
        ],
    },
    {
        title: "Marques",
        links: ["KaVo-compatible", "NSK-compatible", "W&H-compatible", "Bien-Air"],
    },
    {
        title: "Support",
        links: ["Centre d'aide", "Contact", "Maintenance", "Documentation"],
    },
];

const Footer = () => {
    const { data: settings } = useSiteSettings();
    const brandName = settings?.brand_name || BRAND.name;
    const brandEmail = settings?.brand_email || BRAND.email;
    const whatsappDisplay = settings?.whatsapp_display || WHATSAPP_DISPLAY;

    return (
        <footer
            data-testid={FOOTER.root}
            className="relative bg-[#0B0B0D] text-white pt-20 pb-10 overflow-hidden"
        >
            <div className="absolute inset-0 dp-grid-lines-dark opacity-30" />
            <div className="relative max-w-[1320px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
                    <div className="col-span-2">
                        <div className="flex items-center gap-2.5">
                            <svg width="30" height="30" viewBox="0 0 32 32">
                                <defs>
                                    <linearGradient id="ftLogo" x1="0" y1="0" x2="1" y2="1">
                                        <stop offset="0%" stopColor="#0a84ff" />
                                        <stop offset="100%" stopColor="#00e5ff" />
                                    </linearGradient>
                                </defs>
                                <rect x="2" y="2" width="28" height="28" rx="8" fill="#fff" />
                                <path d="M10 8 H17 a7 7 0 0 1 0 14 H10 Z" fill="url(#ftLogo)" />
                                <circle cx="22" cy="22" r="2.4" fill="#00e5ff" />
                            </svg>
                            <span className="font-display text-[20px] font-semibold tracking-tight">
                                {brandName}
                            </span>
                        </div>
                        <p className="mt-5 text-[14px] leading-relaxed text-white/55 max-w-sm">
                            Équipement dentaire premium pour cabinets, cliniques d'implantologie,
                            centres spécialisés et laboratoires.
                        </p>

                        <div className="mt-7 space-y-2 text-[13px] text-white/60">
                            <div className="flex items-center gap-2">
                                <span className="w-1 h-1 rounded-full bg-[#00e5ff]" />
                                {brandEmail}
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-1 h-1 rounded-full bg-[#00e5ff]" />
                                WhatsApp : {whatsappDisplay}
                            </div>
                        </div>
                    </div>

                    {COLUMNS.map((c) => (
                        <div key={c.title}>
                            <div className="dp-eyebrow !text-white/50">{c.title}</div>
                            <ul className="mt-5 space-y-2.5 text-[13.5px]">
                                {c.links.map((l) => (
                                    <li key={typeof l === "string" ? l : l.label}>
                                        {typeof l === "string" ? (
                                            <a
                                                href="#"
                                                className="text-white/65 hover:text-white transition-colors"
                                            >
                                                {l}
                                            </a>
                                        ) : (
                                            <Link
                                                to={l.to}
                                                className="text-white/65 hover:text-white transition-colors"
                                            >
                                                {l.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-16 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] text-white/40">
                    <div>© {new Date().getFullYear()} {brandName} · Tous droits réservés.</div>
                    <div className="flex items-center gap-6">
                        
                        <a href="#" className="hover:text-white/70">Mentions légales</a>
                        <a href="#" className="hover:text-white/70">Confidentialité</a>
                        <a href="#" className="hover:text-white/70">CGV</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
